(function (app) {


    function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    function scrollTo(element, to, duration) {
        var start = element.scrollLeft,
            change = to - start,
            currentTime = 0,
            increment = 20;

        var animateScroll = function () {
            currentTime += increment;
            element.scrollLeft = easeInOutQuad(currentTime, start, change, duration);
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    app.directive("arrowSlider", function () {
        return {
            restrict: "A",
            link: function (scope, $elm, attrs) {
                var wrapperElement = $elm[0].getElementsByClassName("arrow-slider-container")[0];
                var amount;
                var maxScroll;
                var prev = angular.element($elm[0].getElementsByClassName("arrow-slider-left")[0]);
                var next = angular.element($elm[0].getElementsByClassName("arrow-slider-right")[0]);

                prev.on("click", function () {
                    amount = Math.floor(wrapperElement.offsetWidth / 2);
                    maxScroll = wrapperElement.scrollWidth - wrapperElement.offsetWidth;
                    if (wrapperElement.scrollLeft > 0) {
                        var left = wrapperElement.scrollLeft;
                        var scroll = left - amount > 0 ? left - amount : 0;
                        scrollTo(wrapperElement, scroll, 200);
                    }

                });

                next.on("click", function () {
                    amount = Math.floor(wrapperElement.offsetWidth / 2);
                    maxScroll = wrapperElement.scrollWidth - wrapperElement.offsetWidth;
                    if (wrapperElement.scrollLeft < maxScroll) {
                        var left = wrapperElement.scrollLeft;
                        var scroll = left + amount < maxScroll ? left + amount : maxScroll;
                        scrollTo(wrapperElement, scroll, 200);
                    }

                });
            }
        };
    });
})(app);